import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { ArrowLeft, Loader2 } from 'lucide-react'
import { Button } from '@orisini/ui/components/button'
import { Card } from '@orisini/ui/components/card'
import { Input } from '@orisini/ui/components/input'
import { Label } from '@orisini/ui/components/label'
import { accountsApi } from '../lib/accounts'

/**
 * /projects/new — buat project.
 *
 * Cukup nama: tujuan utamanya membuat konten. Akun media sosial ditautkan
 * belakangan dari tab Account kalau hasilnya mau diterbitkan agent; tanpa
 * akun, hasilnya diunduh dari Content Bank.
 */
export default function NewProjectPage() {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [saving, setSaving] = useState(false)

  const simpan = async (e: React.FormEvent) => {
    e.preventDefault()
    setSaving(true)
    try {
      const w = await accountsApi.create({ name })
      toast.success(`${w.name} is ready`)
      navigate(`/projects/${w.id}/topics`, { replace: true })
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Couldn't create the project")
      setSaving(false)
    }
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <div className="space-y-3">
        <Link to="/projects" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
          <ArrowLeft className="size-4" /> Projects
        </Link>
        <h1 className="text-2xl font-semibold tracking-tight">New project</h1>
      </div>

      <form onSubmit={simpan} className="space-y-6">
        <Card className="space-y-4 p-5">
          <div className="space-y-1.5">
            <Label htmlFor="project-name">Project name</Label>
            <Input
              id="project-name"
              value={name}
              maxLength={60}
              autoFocus
              placeholder="e.g. Tech Daily"
              onChange={(e) => setName(e.target.value)}
            />
            <p className="text-xs text-muted-foreground">
              A project has its own topics, brand and content formats. You don't need a social account to start —
              download what it makes, or connect an account later so Orisini Agent can post for you.
            </p>
          </div>
        </Card>
        <div className="flex justify-end gap-2">
          <Button type="submit" disabled={saving || !name.trim()}>
            {saving && <Loader2 className="animate-spin" />}
            Create project
          </Button>
        </div>
      </form>
    </div>
  )
}
